export default "/_next/static/images/5656665dca7bd270dcf2f83b34546f55.jpg";